import axios from 'axios';
import store from 'store';

const state = {
  cancelSource: undefined,
  leads: {},
};

const getters = {
  getLeadsFiltered: st => query => {
    if (typeof st.cancelSource !== typeof undefined) {
      st.cancelSource.cancel();
    }
    st.cancelSource = axios.CancelToken.source();
    axios
      .get(`leads/list?${query}`, { cancelToken: st.cancelSource.token })
      .then(res => {
        st.leads = res.data;
        st.cancelSource = undefined;
      })
      .catch(err => {
        if (!axios.isCancel(err)) {
          throw err;
        }
      });
  },
};

const mutations = {
  setLeads: (st, payload) => {
    st.leads = payload;
  },
};

const actions = {
  getLeads: ({ commit }) => {
    commit('setLeads', {});
    if (
      store.get('permissions').indexOf('leads.index') >= 0 ||
      store.get('permissions').indexOf('leads.index-own') >= 0
    ) {
      axios.get(`leads/list`).then(res => {
        commit('setLeads', res.data);
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/leads.js